import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedUserGuard, LoginGuard } from '@ellf/app-auth';
import { LayoutComponent } from './containers/layout/layout.component';
import { NotFoundPageContainer } from './not-found/not-found-page.container';

const appRoutes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [LoginGuard],
    runGuardsAndResolvers: 'always',
    children: [
      // {
      //   path: 'unauthorized',
      //   pathMatch: 'full',
      //   redirectTo: '',
      //   children: [],
      // },
      // {
      //   path: '',
      //   pathMatch: 'full',
      //   redirectTo: 'dashboard',
      // },
      {
        path: 'preTesting',

        loadChildren: () =>
          import('@ellf/app-pre-testing').then(
            (m) => m.AppLazyPreTestingModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: '',
        pathMatch: 'full',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-dashboard').then(
            (m) => m.AppLazyDashboardModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'statusPage',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-status-page').then(
            (m) => m.AppLazyStatusPageModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'user',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-user').then((m) => m.AppLazyUserModule),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'role',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-role').then((m) => m.AppLazyRoleModule),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'permission',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-permission').then(
            (m) => m.AppLazyPermissionModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'supplier',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-supplier').then(
            (m) => m.AppLazySupplierModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'medicalUnit',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-medical-unit').then(
            (m) => m.AppLazyMedicalUnitModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'contact',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-contact').then((m) => m.AppLazyContactModule),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'manufacturer',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-manufacturer').then(
            (m) => m.AppLazyManufacturerModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      // {
      //   path: 'jobTitle',
      //   // pathMatch: 'full',
      //   loadChildren: () =>
      //     import('@ellf/app-lazy-job-title').then(
      //       (m) => m.AppLazyJobTitleModule
      //     ),
      //   canActivate: [LoggedUserGuard],
      // },
      {
        path: 'testingType',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-testing-type').then(
            (m) => m.AppLazyTestingTypeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'testingStatus',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-testing-status').then(
            (m) => m.AppLazyTestingStatusModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'costClass',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-cost-class').then(
            (m) => m.AppLazyCostClassModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetType',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-type').then(
            (m) => m.AppLazyAssetTypeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'supplyType',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-supply-type').then(
            (m) => m.AppLazySupplyTypeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'contract',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-contract').then(
            (m) => m.AppLazyContractModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'practice',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-practice').then(
            (m) => m.AppLazyPracticeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'costCenter',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-cost-center').then(
            (m) => m.AppLazyCostCenterModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'testing',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-testing').then((m) => m.AppLazyTestingModule),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'documentType',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-document-type').then(
            (m) => m.AppLazyDocumentTypeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'order',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-order').then((m) => m.AppLazyOrderModule),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'asset',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset').then((m) => m.AppLazyAssetModule),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetContract',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-contract').then(
            (m) => m.AppLazyAssetContractModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'location',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-location').then(
            (m) => m.AppLazyLocationModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'costCenterLocation',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-cost-center-location').then(
            (m) => m.AppLazyCostCenterLocationModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetCostCenterLocation',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-cost-center-location').then(
            (m) => m.AppLazyAssetCostCenterLocationModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'orderStatus',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-order-status').then(
            (m) => m.AppLazyOrderStatusModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      // {
      //   path: 'error',
      //   component: ErrorPageComponent,
      //   data: {
      //     'type': 404,
      //     'title': 'Page Not Found',
      //     'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
      //   }
      // },
      {
        path: 'assetCostCenter',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-cost-center').then(
            (m) => m.AppLazyAssetCostCenterModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetCostCenterOrder',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-cost-center-order').then(
            (m) => m.AppLazyAssetCostCenterOrderModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'scheduledMaintenanceType',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-scheduled-maintenance-type').then(
            (m) => m.AppLazyScheduledMaintenanceTypeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'scheduledMaintenanceStatus',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-scheduled-maintenance-status').then(
            (m) => m.AppLazyScheduledMaintenanceStatusModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'scheduledMaintenanceResult',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-scheduled-maintenance-result').then(
            (m) => m.AppLazyScheduledMaintenanceResultModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'scheduledMaintenance',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-scheduled-maintenance').then(
            (m) => m.AppLazyScheduledMaintenanceModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetStatus',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-status').then(
            (m) => m.AppLazyAssetStatusModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetInterventionPriority',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-intervention-priority').then(
            (m) => m.AppLazyAssetInterventionPriorityModule,
          ),
        canActivate: [LoggedUserGuard],
      },

      {
        path: 'correctiveMaintenanceResult',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-corrective-maintenance-result').then(
            (m) => m.AppLazyCorrectiveMaintenanceResultModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'correctiveMaintenanceStatus',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-corrective-maintenance-status').then(
            (m) => m.AppLazyCorrectiveMaintenanceStatusModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'correctiveMaintenance',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-corrective-maintenance').then(
            (m) => m.AppLazyCorrectiveMaintenanceModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'correctiveMaintenanceReminder',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-corrective-maintenance-reminder').then(
            (m) => m.AppLazyCorrectiveMaintenanceReminderModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'correctiveMaintenanceReminderType',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-corrective-maintenance-reminder-type').then(
            (m) => m.AppLazyCorrectiveMaintenanceReminderTypeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'correctiveMaintenanceAction',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-corrective-maintenance-action').then(
            (m) => m.AppLazyCorrectiveMaintenanceActionModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'correctiveMaintenanceActionType',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-corrective-maintenance-action-type').then(
            (m) => m.AppLazyCorrectiveMaintenanceActionTypeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'inOutAsset',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-in-out-asset').then(
            (m) => m.AppLazyInOutAssetModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'scheduledMaintenanceReminderType',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-scheduled-maintenance-reminder-type').then(
            (m) => m.AppLazyScheduledMaintenanceReminderTypeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'scheduledMaintenanceReminder',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-scheduled-maintenance-reminder').then(
            (m) => m.AppLazyScheduledMaintenanceReminderModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'ddt',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-ddt').then((m) => m.AppLazyDdtModule),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'trainingCertificate',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-training-certificate').then(
            (m) => m.AppLazyTrainingCertificateModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'vpnRequest',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-vpn-request').then(
            (m) => m.AppLazyVpnRequestModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'takingCharge',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-taking-charge').then(
            (m) => m.AppLazyTakingChargeModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetOrAccessoryRequest',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-or-accessory-request').then(
            (m) => m.AppLazyAssetOrAccessoryRequestModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'transferOrUnloadingRequest',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-transfer-or-unloading-request').then(
            (m) => m.AppLazyTransferOrUnloadingRequestModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'outOfOrderAssetRequest',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-out-of-order-asset-request').then(
            (m) => m.AppLazyOutOfOrderAssetRequestModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'medicalGasRequest',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-medical-gas-request').then(
            (m) => m.AppLazyMedicalGasRequestModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'correctiveMaintenanceStatistics',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-corrective-maintenance-statistics').then(
            (m) => m.AppLazyCorrectiveMaintenanceStatisticsModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetStatusHistory',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-status-history').then(
            (m) => m.AppLazyAssetStatusHistoryModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'goodToBeTransferredOrUnloaded',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-good-to-be-transferred-or-unloaded').then(
            (m) => m.AppLazyGoodToBeTransferredOrUnloadedModule,
          ),
        canActivate: [LoggedUserGuard],
      },
      {
        path: 'assetToBeTransferredOrUnloaded',
        // pathMatch: 'full',
        loadChildren: () =>
          import('@ellf/app-lazy-asset-to-be-transferred-or-unloaded').then(
            (m) => m.AppLazyAssetToBeTransferredOrUnloadedModule,
          ),
        canActivate: [LoggedUserGuard],
      },
    ],
  },
  {
    path: 'not-found',
    component: NotFoundPageContainer,
  },
  // { path: '**', redirectTo: 'not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
